import Compress from "compress.js"

export const compressImage = function(file) {
  const compress = new Compress()
  const options = {
    size: Infinity, // the max size in MB, defaults to 2MB
    quality: 0.75, // the quality of the image, max is 1,
    maxWidth: 340, // the max width of the output image, defaults to 1920px
    maxHeight: 227, // the max height of the output image, defaults to 1920px
    resize: true, // defaults to true, set false if you do not want to resize the image width and height
  }
  return compress
    .compress(file, options)
    .then((result) => {
      const img = result[0]
      const base64str = img.data
      const imgExt = img.ext
      const pref = img.prefix
      return {
        url: pref + base64str,
        file: Compress.convertBase64ToFile(base64str, imgExt),
      }
    })
    .catch((error) => {
      console.error("compress is error", error)
      throw error
    })
}
